export default __webpack_public_path__ + "static/media/CloseSolid.65438295.svg";